<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="2" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        title:'體表偵測放射治療',
        videosrc:'T02.mp4',

        list:[
          {
            body:"IDENTIFY是一套在放射治療過程中引導病人擺位以進行輻射治療並監控病人的系統。確保工作人員在正確的治療位置使用正確的設定治療正確的病患。無一疏漏。當病患進入您的治療室，工作人員就會取得正確的身份辨識資訊與治療細節的資訊，一切均可輕鬆存取。<br><br>在治療室，IDENTIFY可協助您驗證正確的技術與病患擺位。直觀的介面會引導您設定並使用視覺輔助幫助工作人員進行患者擺位。這有助於工作人員快速、自信地治療患者。運用紅外線偵測並觀察患者體表動作極為小的變化，即時呈現體表資訊，針對在治療過程中呼吸、咳嗽、不自主動作等等自動偵測，提供即時的監控追蹤，無輻射劑量，不會造成輻射曝露。\n"

          }

        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
      this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
